import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation
} from '@angular/core';
import { User } from '@authority-labs/api-interfaces';

@Component({
  selector: 'authority-labs-certificate-signatures',
  templateUrl: './certificate-signatures.component.html',
  styleUrls: ['./certificate-signatures.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom
})
export class CertificateSignaturesComponent {
  @Input() approval: User;
  @Input() assignee: User;
  @Input() date: string;
}
